"use strict";
export default {
  resend(transmissionId) {
    return $.ajax({
      url: `/api/transmissions/${transmissionId}/resend`,
      type: "post",
      contentType: "application/json"
    });
  }
};
